<template>
  <v-card
      flat
      max-width="500"
      mim-width="350"
      class="mx-auto pl-3 pr-3">
    <v-container fluid>
      <v-row>
        <v-img class="mx-auto mt-8 mb-3" justify="center" max-width="150" :src="'/_UPLOAD/logo/img_default_2.png'"></v-img>
      </v-row>
      <v-row class="mb-0">
        <v-col class="pl-0 pb-0" cols="12">
          <v-checkbox color="primary" class="text-primary font-weight-bold text-body-2" v-model="agree" hide-details>
            <template v-slot:label>
              <div>
                정보제공 동의
                <v-dialog v-model="dialog" transition="dialog-bottom-transition">
                  <template v-slot:activator="{ props }">
                    <a class="font-weight-bold text-decoration-underline" @click="dialog = true">보기</a>
                  </template>
                  <v-card>
                    <v-card-text>
                      <p v-html="board"></p>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                          class="text-primary font-weight-bold"
                          variant="text"
                          @click="[agree = false, dialog = false]"
                      >
                        미동의
                      </v-btn>
                      <v-btn
                          class="text-primary font-weight-bold"
                          variant="text"
                          @click="[agree = true, dialog = false]"
                      >
                        동의
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                 (필수)
              </div>
            </template>
          </v-checkbox>
        </v-col>
      </v-row>
      <v-row class="mt-0 pt-0 pb-0">
        <v-col class="pt-0" :cols="isDev ? 12 : 9">
          <v-text-field
              v-model="phoneNumber"
              density="compact"
              variant="outlined"
              label="휴대번호"
              class="text-primary"
              single-line
              hide-details>
          </v-text-field>
        </v-col>
        <v-col v-if="!isDev" class="pt-0 pl-0" cols="3">
          <v-btn
              class="w-100 h-100 bg-primary"
              :disabled="isSmsClickBtn"
              @click.prevent="onSendSMS"
              variant="flat">
            전송
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-if="!isDev" class="mt-0 pb-8">
        <v-col cols="12" >
          <v-text-field
              v-model="smsAuthNumber"
              density="compact"
              variant="outlined"
              label="인증번호"
              class="text-primary"
              single-line
              hide-details
              :disabled="!isValidAuthForm"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" class="pt-0 pb-0">
          <v-card-text class="pa-0 pl-1">
            {{timerStr}}
          </v-card-text>
        </v-col>
      </v-row>
      <v-row class="mt-0">
        <v-col cols="12">
          <v-btn
              class="w-100 bg-primary"
              size="large"
              @click="onLogin"
              variant="outlined"
              :disabled="!isValidAuthButtonForm">
            인증
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-card>

  <MobileFooter></MobileFooter>
</template>

<script>
import {auth, main} from '@/api'
import authStore from '@/store/auth'
import MobileFooter from "@/components/common/MobileFooter";
import commonStore from "@/store/common";

export default {
  name: "Login",
  components: {MobileFooter},
  props: {
    forceRerender: Function
  },
  data() {
    return {
      isAuth: false,
      agree: false,
      phoneNumber: '',
      smsAuthNumber: '',
      rPath: '',
      timer: null,
      timeCounter: 0,
      timerStr: '',
      interval: null,
      dialog: false,
      board: '',
      isSmsClickBtn: false,
    }
  },
  computed: {
    isAuth() {
      return authStore.state.authInfo.token !== null
    },
    isDev() {
      const h = (typeof window !== 'undefined' && window.location && window.location.hostname) || ''
      return h.indexOf('dev') === 0 || h.indexOf('localhost') === 0
    },
    isValidAuthForm() {
      return this.timeCounter > 0 && this.agree && (/^\d{10}$|^\d{11}$/).test(this.phoneNumber)
    },
    isValidAuthButtonForm() {
      if (this.isDev) {
        return this.agree && (/^\d{10}$|^\d{11}$/).test(this.phoneNumber)
      }
      return this.timeCounter > 0 && this.agree && (/^\d{10}$|^\d{11}$/).test(this.phoneNumber) && (/^\d{4}$/).test(this.smsAuthNumber)
    }
  },
  created() {
    this.isAuth = authStore.state.authInfo.token !== null
    if (this.isAuth) {
      this.$router.push('/')
    }

    this.rPath = this.$route.query.rPath || '/'
    this.getAgreementInfo()
  },
  methods: {
    onSendSMS() {
      if (!this.agree) {
        alert("정보제공에 동의해주시기 바랍니다.")
        return
      }

      if (!(/^\d{10}$|^\d{11}$/).test(this.phoneNumber)) {
        alert("휴대번호를 다시 확인해주시기 바랍니다.")
        return
      }

      this.isSmsClickBtn = true
      setTimeout(() => (this.isSmsClickBtn = false), 20000)

      auth.sendSMS(this.phoneNumber)
          .then(data => {
            console.log(data)
            if (data.data.is_send === true) {
              this.timerStart()
            } else {
              this.timerClear()
              alert("SMS 전송에 실패했습니다.")
            }
          })
          .catch(err => {
            if (err.isAlert) {
              this.timerClear()
              alert(err.result.error_message)
            }
          })
    },
    onLogin() {
      const data = {
        phone_number: this.phoneNumber,
        sms_auth_number: this.smsAuthNumber
      }
      authStore.dispatch('login', data)
          .then(result => {
            console.log(result)
            if (result.token) {
              this.$router.push(this.rPath)
            }
          })
    },
    getAgreementInfo() {
      main.getNoticeList(commonStore.state.common.corpCode, 'agree')
          .then(data => {
            console.log('agree', data)
            this.board = data.data.notices[0].comment
          })
          .catch(err => {
            console.log(err)
            if (err.isAlert) {
              alert(err.result.error_message)
            }
          })
    },
    timerStart: function() {
      this.timerClear()
      this.timerStr = "03:00"
      this.timeCounter = 180

      // 1초에 한번씩 start 호출
      this.interval = setInterval(() => {
        this.timeCounter--; //1초씩 감소
        this.timerStr = this.prettyTime();
        if (this.timeCounter <= 0) this.timerClear();
      }, 1000);

      return this.interval
    },
    timerClear: function () {
      if (this.interval != null) {
        clearInterval(this.interval)
      }
      if(this.timer != null){
        this.timeCounter = 0;
        this.timer = null;
      }
      this.timerStr = "00:00";
    },
    prettyTime: function() {
      // 시간 형식으로 변환 리턴
      let t = this.timeCounter / 60;
      let minutes = parseInt(t);
      let secondes = Math.round((t - minutes) * 60);
      return (
          minutes.toString().padStart(2, "0") +
          ":" +
          secondes.toString().padStart(2, "0")
      );
    },
  }
}
</script>